/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgVoicemail(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M18.5 8.25c-2.482 0-3.75 2.052-3.75 3.75s1.268 3.75 3.75 3.75c2.488 0 3.772-2.058 3.75-3.74-.023-1.715-1.276-3.76-3.75-3.76zm-3.706 7.5c-1.032-1.056-1.544-2.499-1.544-3.75 0-2.302 1.731-5.25 5.25-5.25 3.525 0 5.22 2.955 5.25 5.24.03 2.318-1.739 5.26-5.25 5.26h-13a5.25 5.25 0 113.674-1.5h5.62zm-9.294 0a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z'
      />
    </svg>
  );
}

export default SvgVoicemail;
